export const COLORS = {
  bg: "#1a0b2e",
  stage: "#2d1b4e",
  player: "#a855f7", // Rumi is Purple
  sword: "#00ffff",
  enemy: "#76428a",
  projectileDark: "#4a00e0",
  projectileLight: "#ffe600",
  honmoon: "#00ff9d",
  text: "#ffffff",
};